export enum ERROR_STATUS {
	ACCESS = '401',
	DATA = '400',
}

export enum ERROR_CODE {
	// INTERNAL CLIENT ERRORS
	DEVTOOLS_BLOCKED = '0098',
	MEDIA_SERVER_ERROR = '0099',
	// ERROR_STATUS.ACCESS
	UNAUTHORIZED = '1001',
	INVALID_TOKEN = '1002',
	ERROR_TOKEN = '1003',
	INVALID_PROCESS = '1004',
	PROCESS_FINISHED = '1005',
	PROCESS_MISMATCH = '1006',
	INVALID_COMPANY = '1007',
	INVALID_APIKEY = '1008',
	INVALID_PROFILE = '1009',
	PROFILE_EXPIRED = '1014',
	PROCESS_ACTIVE_IN_OTHER_TAB = '1015',
	// ERROR_STATUS.DATA
	INVALID_OPERATION = '1101',
	NOT_FOUND_PROFILE = '1102',
	INVALID_STATE = '1103',
	INVALID_OPERATION_TYPE = '1104',
	INVALID_ACTION_TYPE = '1105',
	INVALID_ACTION = '1106',
	INVALID_DEVICE = '1107',
	REQUIRED_IMAGE = '1108',
	// OPERATIONS
	NOT_BE_READ = '2001',
	NOT_DETERMINED_SIDE = '2002',
	/** Tipo de documento no válido / no permitido (UX front = 2070; NIF-1023). */
	DOC_TYPE_NOT_VALID = '2003',
	INCORRECT_SIDE = '2004',
	INCORRECT_NUMBER_OF_DOCUMENTS = '2005',
	ERROR_MRZ = '2006',
	MAXIMUM_TRIES_EXCEEDED = '2007',
	NO_IMAGES = '2008',
	STATE_NOT_FOUND = '2009',
	TIME_READ_EXCEEDED = '2010',
	NO_OCR_FRONT_FOUND = '2011',
	FRAUD_SCORING_ILLEGAL_AGE = '2012',
	FRAUD_SCORING_EXPIRED_DOCUMENT = '2013',
	MATCH_DATA_ERROR = '2014',
	FRAUD_SCORING_AEAT_NOT_VERIFY = '2015',
	POLICY_CHECK_REQUIRED = '2016',
	MATCH_DATA_EMPTY = '2017',
	NOT_ELIGIBLE_SCRIPTURE_API = '2018',
	/** Legado Librebor genérico (pre NIF-800). */
	KO_LIBREBOR = '2019',
	FALLBACK_MANUAL = '2024',
	SCRIPTURE_NEVER_RETRY = '2031',
	NO_FACE_IN_DOCUMENT = '2032',
	SCRIPTURE_NOT_FOUND = '2033',
	/** Faltan datos de dirección en el documento (validate_address; NIF-1085). */
	MISSING_ADDRESS = '2038',
	/** Número de equipo no extraído (validate_team_number). */
	MISSING_TEAM_NUMBER = '2039',
	PERMISSION_NOT_GRANTED = '2047',
	/** NIF-995: fallo interno / persistencia DOCUMENTS (no abandono 2020). */
	DOCUMENTS_INTERNAL_EXTRACT = '2048',
	/** SCRIPTURE/BORME: persona no coincide (NIF-800). */
	SCRIPTURE_PERSON_NOT_MATCHED = '2053',
	/** SCRIPTURE/BORME: empresa no activa (NIF-800). */
	SCRIPTURE_COMPANY_NOT_ACTIVE = '2054',
	/** SCRIPTURE/BORME: error genérico de consulta (NIF-800). */
	SCRIPTURE_QUERY_ERROR = '2055',
	/** SCRIPTURE PDF: CIF no coincide (NIF-800). */
	SCRIPTURE_CIF_NOT_MATCHED = '2056',
	/** SCRIPTURE PDF: documento inválido/ilegible (NIF-800). */
	SCRIPTURE_INVALID = '2057',
	/** Tipo de documento no permitido para la identificación (allowed_docs). */
	DOC_TYPE_NOT_ALLOWED = '2070',
	/** País del documento no permitido (allowed_docs). */
	COUNTRY_NOT_ALLOWED = '2071',
	INSUFFICIENT_OCR_DATA = '2072',
	/** Anverso y reverso no corresponden al mismo documento (NIF-984; no reutilizar 2006/MRZ). */
	DIFFERENT_DOCUMENTS = '2073',
	/** Anverso y reverso en la misma imagen al adjuntar (NIF-1082; no reutilizar 2004). */
	BOTH_SIDES_IN_ONE_IMAGE = '2074',
	/** Imagen persistida pero aún no accesible (GCS); reintento HTTP sin re-captura (NIF-646). */
	STORAGE_NOT_AVAILABLE = '2099',
	/** Proveedor externo caído (Vision/Rekognition/antispoof); no es rechazo KYC (NIF-944). */
	SYSTEM_UNAVAILABLE = '3099',
	// FINISH OPERATIONS
	ANTI_FRAUD = '2101',
	PROHIBITED_CAMERA = '2102',
	BARCODE_MISMATCH = '2110',
	BARCODE_MAX_ATTEMPTS = '2111',
}

export interface IErrorResponse {
	code: ERROR_STATUS;
	error: {
		error_code: ERROR_CODE;
		/** Motivo de negocio cuando error_code es wrap de flujo (2024/2007). NIF-800 SCRIPTURE. */
		business_error_code?: ERROR_CODE | number | string;
		/** Mensaje técnico / histórico del journey (puede ir en inglés). */
		msg: string;
		/** Copy catálogo BBDD en locale de la petición (NIF-748; mismo contrato que admin). */
		title?: string;
		message?: string;
	};
	action?: () => void | Promise<void>;
	/** Pantalla MEDIA_SERVER: ocultar RETRY y mostrar mensaje de espera. */
	waiting?: boolean;
}
